import { render, staticRenderFns } from "./TableRawMaterialsGlobal.vue?vue&type=template&id=28bf36fe&scoped=true&"
import script from "./TableRawMaterialsGlobal.vue?vue&type=script&lang=js&"
export * from "./TableRawMaterialsGlobal.vue?vue&type=script&lang=js&"
import style0 from "./TableRawMaterialsGlobal.vue?vue&type=style&index=0&id=28bf36fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf36fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VProgressLinear,VSpacer})
